import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.other.spacing._12,
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    minWidth: 0,
  },
  icon: {
    flexShrink: 0,
    objectFit: 'contain',
  },
  viewAll: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: theme.other.spacing._4,
  },
}));
